import { useStore } from '@dh-io-otb/shared/src/composables/store.composable';
import { Maybe } from '@dh-io-otb/shared/src/graphql/schema';

export default class DatetimePickerService {
  static commitSelectedPeriod(value: any): void {
    const { commit } = useStore();
    commit('selectedPeriod', value);
  }

  static commitSelectedDay(day: Maybe<Date>): void {
    const { commit, state } = useStore();
    if (day === null) {
      commit('selectedDay', state.otbcFlow.firstAvailableDate);
    } else {
      commit('selectedDay', day);
    }
  }
}
